var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("离职委派")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "query" }, [
        _c("p", { staticClass: "header" }, [_vm._v("查询客户")]),
        _c(
          "div",
          { staticClass: "polling" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户手机号码" },
                      model: {
                        value: _vm.queryForm.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "info", $$v)
                        },
                        expression: "queryForm.info",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy- MM- dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "入线方式" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "选择入线方式",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.Incoming,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "Incoming", $$v)
                          },
                          expression: "queryForm.Incoming",
                        },
                      },
                      _vm._l(_vm.line, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.name, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "客服" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "请选择客服" },
                        model: {
                          value: _vm.queryForm.service,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "service", $$v)
                          },
                          expression: "queryForm.service",
                        },
                      },
                      _vm._l(_vm.customer, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.reallyName, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户等级" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请选择客户等级",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.category,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "category", $$v)
                          },
                          expression: "queryForm.category",
                        },
                      },
                      _vm._l(_vm.rank, function (items) {
                        return _c("el-option", {
                          key: items.dictId,
                          attrs: { label: items.dictName, value: items.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      { attrs: { type: "danger" }, on: { click: _vm.reset } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _vm.parArray.indexOf("wpkh") != -1
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.allocation },
                },
                [_vm._v("批量分配")]
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { "tooltip-effect": "dark", data: _vm.tableData.list },
              on: { "selection-change": _vm.SelectionCurson },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "姓名" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.is_null(scope.row.phoneTwo)
                          ? _c("p", [_vm._v(_vm._s(scope.row.phone))])
                          : _c("div", [
                              _c("div", [_vm._v(_vm._s(scope.row.phone))]),
                              _c("div", [_vm._v(_vm._s(scope.row.phoneTwo))]),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "address",
                  label: "地址",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "userLevel", label: "客户等级" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.is_null(scope.row.userLevel)
                          ? _c("p", [_vm._v("--")])
                          : _c("p", [_vm._v(_vm._s(scope.row.userLevel))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "userIntention", label: "客户意向" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.is_null(scope.row.userIntention)
                          ? _c("span", [_vm._v("--")])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.userIntention)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "customerName", label: "客服人员" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdTime",
                  label: "进度时间",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "历史订单记录",
                              placement: "top-start",
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.tolist(scope.row)
                                  },
                                },
                              },
                              [_vm._v("历史")]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tableData.totalNum >= 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-size": _vm.pageSize,
                    layout: "total,sizes,prev, pager, next",
                    "prev-text": "上一页",
                    "next-text": "下一页",
                    total: _vm.tableData.totalNum,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                    "update:currentPage": function ($event) {
                      _vm.pageNo = $event
                    },
                    "update:current-page": function ($event) {
                      _vm.pageNo = $event
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.Visible,
            "append-to-body": true,
            title: "分配资源",
          },
          on: {
            "update:visible": function ($event) {
              _vm.Visible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tree" },
            [
              _c("el-input", {
                staticStyle: { margin: "0 0px 20px" },
                attrs: { placeholder: "输入关键字进行搜索" },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
              _c("el-tree", {
                ref: "tree",
                staticClass: "el-menu-vertical-demo",
                attrs: {
                  data: _vm.tree,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "default-expand-all": true,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c("div", { staticStyle: { position: "relative" } }, [
            _c(
              "div",
              { staticClass: "table1" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tablePerson.list,
                      "row-key": _vm.getRowKey,
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        "reserve-selection": true,
                        width: "50",
                        align: "center",
                      },
                      model: {
                        value: _vm.multipleSelection,
                        callback: function ($$v) {
                          _vm.multipleSelection = $$v
                        },
                        expression: "multipleSelection",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "100" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "姓名" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("p", [_vm._v(_vm._s(props.row.reallyName))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "联系电话", prop: "phoneNumber" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "所在部门" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.row.orgName))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "职位", prop: "positionName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "员工状态", prop: "statusName" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.tablePerson.totalNum > 0
              ? _c("div", { staticClass: "page2" }, [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.stafpage,
                          "page-size": _vm.pageSize,
                          "page-sizes": [10, 20, 30, 50],
                          layout: "total,sizes,prev, pager, next",
                          "prev-text": "上一页",
                          "next-text": "下一页",
                          total: _vm.tablePerson.totalNum,
                        },
                        on: {
                          "size-change": _vm.handleSizeEmplay,
                          "current-change": _vm.handleCurrentEmplay,
                          "update:currentPage": function ($event) {
                            _vm.stafpage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.stafpage = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.Visible = false
                      _vm.toggleSelection()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.Visible = false
                      _vm.submission()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }